/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import {Injectable} from '@angular/core';
import {AbstractResourceService} from '@irian-ro/abstract-resource';
import { HttpClient } from '@angular/common/http';
import {EnvironmentService} from "@irian-ro/util-environment";
import { ComplaintDtoModel, ComplaintListMetaModel, ComplaintListModel } from '@well/domain';

@Injectable({
  providedIn: 'root'
})
export class ComplaintResourceService extends AbstractResourceService<ComplaintListModel, ComplaintDtoModel, ComplaintListMetaModel, any> {

  constructor(httpClient: HttpClient, environmentService: EnvironmentService) {
    super(
      httpClient,
      environmentService.getEnvironmentProperty('complaintUrl'),
      ComplaintListModel,
      ComplaintDtoModel
    );
  }

  resolveComplaint(uuid: string) {
    return this.httpClient?.post(`${this.url}/${uuid}/resolve`, null, {headers: this.headers})
      .pipe(this.getDtoMapper());
  }
}
